import { Component, OnInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
// import { AlertService } from 'mychannel-shared-libs';
// import { SweetAlert } from '../../alert/sweet-alert'
import Swal from 'sweetalert2';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { schema } from './schema.value';

declare var JSONEditor: any;

@Component({
  standalone: false,
  selector: 'app-json-editor',
  templateUrl: './json-editor.component.html',
  styleUrls: ['./json-editor.component.scss']
})
export class JsonEditorPageComponent implements OnInit, OnChanges {
  @ViewChild('editor') editor!: JsonEditorComponent;
  public editorOptions: JsonEditorOptions;


  @Input()
  json: any;

  @Input()
  allowUpdate!: boolean;
  @Input()
  disableUpdate: boolean=false;

  @Input()
  mode: string=''

  @Output()
  completed: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  close: EventEmitter<void> = new EventEmitter<void>();

  jsoneditor: any;
  jsonChange: any;

  @Input()
  allowAdd: boolean=false

  constructor(
    // private alertService: SweetAlert

  ) {
    this.editorOptions = new JsonEditorOptions;
    this.editorOptions.schema = schema;
    this.editorOptions.search = true;
    this.editorOptions.mainMenuBar = true;
    this.editorOptions.navigationBar = true;
    // this.editorOptions.statusBar = true;



    this.editorOptions.modes = ['text', 'tree', 'view'];
    this.editorOptions.mode = "view"
    // this.initEditorOptions(this.editorOptions);
  }

  ngOnInit() {
    const self: any = this;
    // this.jsoneditor = new JSONEditor(this.jsoneditorRef.nativeElement, {
    //   mode: this.mode || 'view',
    //   modes: ['text', 'tree', 'view'], // allowed modes
    //   onError: function (err:any) {
    //     self.alertService.error(err.toString());
    //   }
    // });
    // this.jsoneditor.set(Object.assign(Array.isArray(this.json) ? [] : {}, this.json));
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (this.jsoneditor && changes['json'] && changes['json'].currentValue) {
    //   this.jsoneditor.set(changes['json'].currentValue);
    // }
  }
  changeLog(event:any) {
    // console.log(event);
    // console.log('change:', this.editor);
    if(event?.target?.className !='jsoneditor-text'){
      const editorJson = this.editor.getEditor();
      editorJson.validate();
      const errors = editorJson.validateSchema.errors;
      if (errors && errors.length > 0) {
        console.log('Errors found');
        editorJson.set(this.jsonChange??this.json);
      } else {
        // this.jsonChange = event;
        if (event?.target) {
          this.jsonChange = this.editor.get();
        } else {
          this.jsonChange = event;
        }
      }
    }

  }
  initEditorOptions(editorOptions:any) {
    // this.editorOptions.mode = 'code'; // set only one mode
    editorOptions.modes = [ 'text', 'tree', 'view']; // set all allowed modes
    // this.editorOptions.ace = (<any>window).ace.edit('editor');
  }

  onUpdate() {
    this.question('Are you sure want to update data?').then((data: any) => {
      if (!data.value) {
        return;
      }
      try {
        this.completed.emit(this.jsonChange??this.json);
      } catch (err:any) {
        this.error(err.toString());
      }
    });
  }

  onAdd() {
    this.question('Are you sure want to Add data?').then((data: any) => {
      if (!data.value) {
        return;
      }
      try {
        this.completed.emit(this.jsonChange??this.json);
      } catch (err:any) {
        this.error(err.toString());
      }
    });
  }
  swalSuccess(msg: string) {
    Swal.fire('Finish!', msg, 'success');
  }
  error(msg: string) {
    return Swal.fire({
      icon: "error",
      title: "Error",
      text: msg
    });
  }
  success(msg: string) {
    return Swal.fire({
      icon: "success",
      title: "Success",
      text: msg
    });
  }
  question(msg:string){
    return Swal.fire({
      icon: "question",
      // title: "Are you sure?",
      showCancelButton: true,
      cancelButtonColor: '#d5d5d5',
      confirmButtonColor: '#cced61',
      cancelButtonText: '<div style="color:#546e7a"> Cancel </div>',
      confirmButtonText: '<div style="color:#546e7a"> Confirm </div>',
      text: msg,
      reverseButtons:true
    });

  }
  notify(data:any){
    return Swal.fire(data);
  }

}
